unit UErrorHandling;

interface

uses
  WEBLib.WebTools,
  System.SysUtils,
  WebLib.Forms,
  Web,
  XData.Web.Client,
  WEBLib.Dialogs;

type

TErrors = class
  code: Integer;
  errorMessage: string;
  handled: boolean;
end;

TErrorHandling = class
  public
    class procedure AppException(Sender:TObject; Error: Exception);
    class procedure AppError(Sender: TObject; AError: TApplicationError;
      var Handled: Boolean);
    class procedure DisplayServerError( const E: EXDataClientRequestException);
end;

implementation

class procedure TErrorHandling.AppException(Sender: TObject; Error: Exception);
begin
  OutputDebugString('From Application.OnException: '+Error.Message);
  OutputDebugString('Object from Application.OnException');
  OutputDebugString(Error.ToString);
end;

class procedure TErrorHandling.DisplayServerError(
  const E: EXDataClientRequestException);
begin
  MessageDlg(E.ErrorResult.ErrorMessage, mtError, [mbOK]);
end;

class procedure TErrorHandling.AppError(Sender: TObject; AError: TApplicationError;
  var Handled:Boolean);
begin
  Handled:=True;
  OutputDebugString('From Application.OnError: '+AError.AMessage);
  OutputDebugString('Object from Application.OnError');
end;

end.
